import React from 'react';
import { IoMdPhotos } from "react-icons/io";
import { useNavigate } from 'react-router-dom';

function PropertyCard({ imageUrl, propertyId, title, price, size, location, status, photosCount, date, visits=100 }) {
    const navigate = useNavigate();

    return (
        <div 
            onClick={() => { navigate(`/propertydetail/${propertyId}`) }}
            className="max-w-[300px] min-w-[300px] max-h-[320px] h-[330px] rounded-[10px] overflow-hidden border border-gray-300 transition duration-300 hover:shadow-xl cursor-pointer group relative">
            
            <div className='w-full h-[150px] rounded-t-sm overflow-hidden relative'>
                <img 
                    className="w-full h-full transition duration-300 transform group-hover:scale-110" 
                    src={imageUrl} 
                    alt="Property"
                    onError={(e) => { e.target.src = "https://www.ikonmarket.com/assets/images/marketing-articles/luxury-home.jpg" }} 
                />
                <div className="absolute bottom-2 rounded left-2 bg-[#303030] bg-opacity-70 text-white flex items-center p-1">
                    <IoMdPhotos className="text-xs mr-1" />
                    <span className="text-xs">{photosCount}</span>
                </div>
            </div>
            
            <div className="px-3 py-2  flex flex-col h-full">
                <div className="font-normal text-sm text-[#303030]">{title}</div>
                <p className="text-[#303030] text-[18px] font-semibold mb-2">
                    {price} | {size}
                </p>
                <p className="text-gray-600 text-sm h-[40px] line-clamp-2">{location}</p>

                <div className='flex justify-between items-start'>
                    <div className="transition duration-500 ease-in-out transform group-hover:translate-y-10 group-hover:opacity-0 w-[60%]">
                        <span className="inline-block rounded-full py-1 text-sm font-normal text-gray-700 mr-2 mb-2">
                            {status}
                        </span>
                    </div>
                </div>

                {/* Positioned bottom-right for Posted On and Visits */}
                <div className="absolute bottom-3 right-3 text-[10px] text-black flex flex-col items-end space-y-1">
                    <p>Posted On: {date}</p>
                    <p>Visits: {visits}</p>
                </div>

                <button className="absolute bottom-[20px] left-3 right-3 bg-[#2b463c] text-white text-sm font-semibold py-1 rounded-full opacity-0 transition duration-300 ease-in-out transform group-hover:translate-y-[-12px] group-hover:opacity-100 w-[120px] px-1">
                    View Details
                </button>
            </div>
        </div>
    );
}

export default PropertyCard;
